import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

import { LOCAL_COLORS } from 'styles/constants';
import { desktopOnly, mobileOnly } from 'styles/mixins/displayMobileDesktop';
import { Theme } from '../../types';

export const BeforeAfterCaseContainer = styled.div<{ imageOnly: boolean }>`
  display: flex;
  flex-direction: column;
  min-width: 300px;
  max-width: 416px;
  margin-right: 16px;
  padding: ${SPACER.xsmall};

  ${MEDIA_QUERIES.mdUp} {
    :last-child {
      margin-right: 0px;
    }

    padding: 0;
    ${({ imageOnly }) => imageOnly && 'max-width: unset;'}
  }

  ${MEDIA_QUERIES.xlUp} {
    padding: ${SPACER.xsmall};
  }
`;

export const ImageRow = styled.div`
  display: flex;
  gap: ${SPACER.x2small};
  background-color: ${LOCAL_COLORS.surfaceWhite};
`;

export const GoalsContainer = styled.div`
  display: flex;
  gap: ${SPACER.small};
  align-items: flex-start;
  font-size: 12px;
  line-height: 150%;
`;

export const GoalHeadline = styled.h2`
  font-weight: 700;
  font-size: 12px;
`;

export const SkinGoal = styled.div`
  padding: 2px 2px 3px;
  background: #f5f2ec;

  color: ${LOCAL_COLORS.textSubtle};
  border-top: 2px solid ${LOCAL_COLORS.corePurple600};
`;

export const BeforeLabel = styled.span`
  position: absolute;
  font-size: 12px;
  font-weight: 700;
  line-height: 150%;
  text-wrap: nowrap;
  top: 0;
  left: 0;
  background-color: #fa824f;
  padding: 1px 5px;
`;

export const AfterLabel = styled.span`
  position: absolute;
  font-size: 12px;
  font-weight: 700;
  line-height: 150%;
  text-wrap: nowrap;
  top: 0;
  right: 0;
  background-color: #fa824f;
  padding: 1px 5px;
`;

export const Disclaimer = styled.small`
  color: ${LOCAL_COLORS.purple75};
`;

export const InfoContainer = styled.div<{ themeType: Theme }>`
  flex-grow: 1;
  background-color: ${LOCAL_COLORS.surfaceWhite};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${({ themeType }) =>
    themeType === 'primary' ? `${SPACER.large} 0 0` : `${SPACER.small}`};

  ${MEDIA_QUERIES.mdUp} {
    padding: ${({ themeType }) =>
      themeType === 'primary'
        ? `${SPACER.large} ${SPACER.medium} ${SPACER.medium}`
        : `${SPACER.large}`};
  }

  ${MEDIA_QUERIES.xlUp} {
    padding: ${({ themeType }) =>
      themeType === 'primary' ? `${SPACER.large} 0 0` : `${SPACER.large}`};
  }
`;

export const QuoteBodyContainer = styled.div``;

export const Quotation = styled.div`
  color: #6554e8;
  margin-bottom: ${SPACER.medium};
`;

export const QuoteSummary = styled.h3`
  font-size: 20px;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 6px;
`;

export const QuoteBody = styled.div`
  font-size: 16px;
  line-height: 132%;
`;

export const imageContainerStyles = css`
  position: relative;

  & > div {
    height: 100%;
  }
`;

export const DesktopImageContainer = styled.div`
  ${desktopOnly()}
  ${imageContainerStyles}
`;

export const MobileImageContainer = styled.div`
  ${mobileOnly()}
  ${imageContainerStyles}
`;

export const ClickableLogo = styled.div`
  cursor: pointer;
`;
